import {
  FormControl,
  FormLabel,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';

interface Props {
  name: string;
  value: string;
  handleChange: any;
  disabled?: boolean;
  placeholder: string;
  title: string;
  variant?: string;
  isRequiredFalse?: boolean;
}
const CustomPasswordInput: React.FC<Props> = ({
  disabled,
  handleChange,
  name,
  value,
  placeholder,
  title,
  variant,
  isRequiredFalse,
}) => {
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);
  return (
    <>
      <FormControl isRequired={isRequiredFalse ? false : true}>
        <FormLabel
          display="flex"
          ms="4px"
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          mb="8px"
        >
          {title}
        </FormLabel>
        <InputGroup size="md">
          <Input
            variant={variant ? variant : 'auth'}
            fontSize="sm"
            ms={{ base: '0px', md: '0px' }}
            type={show ? 'text' : 'password'}
            placeholder={placeholder}
            mb="24px"
            fontWeight="500"
            size="lg"
            value={value}
            name={name}
            onChange={handleChange}
            disabled={disabled}
          />
          <InputRightElement display="flex" alignItems="center" mt="4px">
            <Icon
              color={textColorSecondary}
              _hover={{ cursor: 'pointer' }}
              as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
              onClick={handleClick}
            />
          </InputRightElement>
        </InputGroup>
      </FormControl>
    </>
  );
};

export default CustomPasswordInput;
